import React, { Component } from "react";
import { Provider } from "react-redux";
import configureStore from "../configureStore";
import App from "./App.jsx";

const store = configureStore();

export default class Root extends Component {
  render() {
    return (
      <Provider store={store}>
        {() => <App />}
      </Provider>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/Root.jsx
 **/